import { render, staticRenderFns } from "./FarmerDetail.vue?vue&type=template&id=630d41a3&scoped=true"
import script from "./FarmerDetail.vue?vue&type=script&lang=js"
export * from "./FarmerDetail.vue?vue&type=script&lang=js"
import style0 from "./FarmerDetail.vue?vue&type=style&index=0&id=630d41a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630d41a3",
  null
  
)

export default component.exports